<!--
  Same layout as voyage-credit-purchase.component.html — see that file's
  header for why the price list doubles as the "what it buys" summary. Kept
  as a literal copy rather than a shared template because the component pair
  above it is a deliberate duplication (see this component's header); a
  shared template referencing two different component classes would be the
  wrong place to first pay down that duplication.
-->
<div class="vcp">
  <div class="vcp__head">
    <h4 class="vcp__title">Buy Credits</h4>
  </div>

  <div class="vcp__body" id="scrollcustom">
    <div class="vcp__body-inner">
      <p class="vcp__lede">
        Credits are spent on the actions below, any time while your time of interest (TOI) is open.
      </p>

      <form class="vcp__grid" [formGroup]="creditFormGroup" (ngSubmit)="buyCredits()">
        <section class="vcp__card vcp__amount">
          <h5 class="vcp__card-title">How many?</h5>

          <div class="vcp__presets">
            <button
              type="button"
              class="vcp__preset"
              *ngFor="let chip of creditChips"
              [class.is-on]="creditsEntered === chip"
              (click)="setCredits(chip)"
            >
              <span class="vcp__preset-qty">{{ formatCredits(chip) }}</span>
              <span class="vcp__preset-cost" *ngIf="showCreditPricing">
                {{ costLabel(chip * creditUnitPrice) }}
              </span>
            </button>
          </div>

          <div class="vcp__row">
            <div class="vcp__entry">
              <div class="vcp__field-row">
                <div class="vcp__field" [class.is-bad]="!!creditMessage">
                  <input
                    class="vcp__field-input"
                    type="number"
                    inputmode="numeric"
                    formControlName="credits"
                    aria-label="Credits to buy"
                    placeholder="{{ creditChips[1] || minCredits }}"
                    [attr.min]="minCredits"
                    [attr.max]="maxCredits"
                  />
                  <span class="vcp__field-unit">credits</span>
                </div>

                <span
                  class="vcp__rate"
                  *ngIf="showCreditPricing"
                  [attr.aria-label]="costLabel(creditUnitPrice) + ' per credit'"
                >
                  &times; {{ costLabel(creditUnitPrice) }}
                </span>
              </div>

              <p
                class="vcp__note"
                [class.is-bad]="!!creditMessage"
                [attr.aria-live]="creditMessage ? 'polite' : null"
              >
                <mat-icon class="material-icons-outlined" *ngIf="creditMessage">
                  error_outline
                </mat-icon>
                <span>{{ creditMessage || rangeHint }}</span>
              </p>
            </div>

            <div class="vcp__total" [class.is-on]="hasSummary" aria-live="polite">
              <span class="vcp__total-key">Total</span>
              <span class="vcp__total-val">{{ totalLabel }}</span>
              <span class="vcp__total-sub">{{ totalSubLabel }}</span>
            </div>
          </div>
        </section>

        <section class="vcp__card vcp__buys">
          <h5 class="vcp__card-title">
            What
            <b *ngIf="hasSummary">{{ formatCredits(creditsEntered) }} credits</b>
            <ng-container *ngIf="!hasSummary">it</ng-container>
            buys
          </h5>

          <!-- Shared component — see this file's own header for why it is
               reused directly rather than duplicated: it holds no opinion
               about which operator's catalogue it was handed. -->
          <app-voyage-credit-catalogue
            [actions]="creditActions"
            [unitPrice]="creditUnitPrice"
            [showPricing]="showCreditPricing"
            [credits]="hasSummary ? creditsEntered : 0"
          ></app-voyage-credit-catalogue>

          <p class="vcp__mix" *ngIf="creditActions.length > 1">…or any mix of these.</p>
        </section>
      </form>
    </div>
  </div>

  <div class="vcp__foot">
    <span class="vcp__foot-note">Unused credits can be refunded on request.</span>
    <button class="custom-button" type="button" (click)="onNoClick()">Cancel</button>
    <button
      mat-stroked-button
      class="submit"
      type="button"
      [disabled]="creditError"
      (click)="buyCredits()"
    >
      {{ buyLabel }}
    </button>
  </div>
</div>
